import React from 'react';

const Visa = () => {
  return (
    <div className="visa-tab" style={{ padding: '20px' }}>
      <h2 style={{ color: '#FFD700', marginBottom: '10px' }}>Visa Integration</h2>
      <p style={{ marginBottom: '20px', color: '#ccc' }}>
        Coming Soon: Mock virtual Visa card for fiat spending with USD1 conversion.
      </p>

      <div style={{
        background: '#111',
        border: '1px solid #FFD700',
        padding: '20px',
        borderRadius: '8px',
        marginBottom: '20px',
      }}>
        <h3 style={{ color: '#FFD700', marginBottom: '15px' }}>Virtual Card Preview</h3>
        <p style={{ color: '#ccc', marginBottom: '10px' }}>
          Card Number: **** **** **** 1234 (Mock)
        </p>
        <p style={{ color: '#ccc', marginBottom: '10px' }}>
          Expiry: 12/28
        </p>
        <p style={{ color: '#ccc', marginBottom: '0' }}>
          CVV: ***
        </p>
      </div>

      {/* Mock Form for Future Use */}
      <div style={{ marginBottom: '20px' }}>
        <label style={{
          display: 'block',
          marginBottom: '5px',
          color: '#FFD700',
          fontWeight: 'bold',
        }}>
          Cardholder Name:
        </label>
        <input
          type="text"
          placeholder="John Connor"
          disabled
          style={{
            width: '100%',
            padding: '10px',
            marginBottom: '15px',
            background: '#111',
            color: '#FFD700',
            border: '1px solid #FFD700',
            borderRadius: '4px',
            opacity: 0.6,
          }}
        />

        <label style={{
          display: 'block',
          marginBottom: '5px',
          color: '#FFD700',
          fontWeight: 'bold',
        }}>
          Amount to Convert to USD1:
        </label>
        <input
          type="number"
          placeholder="0.00 (Mock)"
          disabled
          style={{
            width: '100%',
            padding: '10px',
            marginBottom: '15px',
            background: '#111',
            color: '#FFD700',
            border: '1px solid #FFD700',
            borderRadius: '4px',
            opacity: 0.6,
          }}
        />
      </div>

      <button
        disabled
        title="Feature in development - Check back soon for USD1 conversion!"
        style={{
          width: '100%',
          padding: '12px',
          borderRadius: '5px',
          background: '#333',
          border: '2px solid #666',
          color: '#666',
          cursor: 'not-allowed',
          fontWeight: 'bold',
        }}
      >
        Generate Virtual Card (Coming Soon)
      </button>

      <div style={{
        marginTop: '20px',
        padding: '15px',
        background: '#112',
        border: '1px solid #FFD700',
        borderRadius: '8px',
      }}>
        <h4 style={{ color: '#FFD700', marginBottom: '10px' }}>Coming Features:</h4>
        <ul style={{ color: '#ccc', margin: '0', paddingLeft: '20px' }}>
          <li>Instant USD1 to fiat conversion</li>
          <li>Virtual card generation</li>
          <li>Real-time spending notifications</li>
          <li>Spending limits and controls</li>
        </ul>
      </div>
    </div>
  );
};

export default Visa;
